import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'

import { Col, DatePicker, Form, Input, InputNumber, message, Modal, Row, TimePicker, Typography, Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import RichTextEditor from '../base/RichTextEditor'
import { convertToHTML } from 'draft-convert'

const { Title, Text } = Typography

const { TextArea } = Input

const NewsAddForm = ({ visible, toLoad, editId, onSubmit, onCancel, media, customRequest }) => {
  //destructures props
  const [form] = Form.useForm()
  const formRef = useRef()
  const inputRef = useRef()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')

  useEffect(() => {
    if (toLoad && inputRef.current && visible) {
      inputRef.current.loadCurr()
    }
    if (media) {
      setStartDate(media.start_date)
      setEndDate(media.end_date)
      setStartTime(media.start_time)
      setEndTime(media.end_time)
      form.setFieldsValue({
        title: media.title,
        subtitle: media.subtitle,
        location: media.location,
        year: media.year,
        link: media.link
      })
    }
    formRef.current = media
  }, [toLoad, visible])

  useEffect(() => {
    // if (formRef.current === null && media) {
    //     console.log(media)
    // }
  }, [])

  return (
    media && (
      <Modal
        visible={visible}
        title={editId ? 'Edit News' : 'Add News'}
        okText={editId ? 'Update' : 'Add'}
        onCancel={onCancel}
        width={'66vw'}
        style={{ top: 20 }}
        onOk={() => {
          form
            .validateFields(['title', 'year'])
            .then((values) => {
              let formData = form.getFieldsValue()
              formData = {
                ...formData,
                start_date: startDate,
                end_date: endDate,
                start_time: startTime,
                end_time: endTime
              }
              const editor = inputRef.current?.state.editorState
              if (editor && editor.getCurrentContent().hasText()) {
                const html = convertToHTML(editor.getCurrentContent())
                formData['body'] = html
              }
              onSubmit(editId, formData)
            })
            .catch(() => {
              message.error('Please fill out required title or year').then(() => {})
            })
        }}
      >
        <Form
          form={form}
          requiredMark={'optional'}
          layout={'vertical'}
          name='MediaForm'
          initialValues={{
            title: media.title,
            body: media.body,
            location: media.location,
            year: media.year,
            link: media.link
          }}
        >
          <div
            style={{
              width: '100%',
              height: '66vh',
              borderTop: '1px solid rgba(0, 0, 0, 0.15)',
              borderBottom: '1px solid rgba(0, 0, 0, 0.15)',
              paddingTop: 6,
              paddingBottom: 6,
              paddingRight: 24,
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
          >
            <Row spacing={4}>
              <Col xs={24}>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    marginTop: 3,
                    gap: 2,
                    flexDirection: 'column'
                  }}
                >
                  <Form.Item
                    name='title'
                    label='Title'
                    rules={[
                      {
                        required: true,
                        message: 'Please input the title!',
                        type: 'string',
                        max: 100,
                        min: 1
                      }
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 1,
                      justifyContent: 'space-between'
                    }}
                  >
                    <Form.Item
                      name='year'
                      label='Year'
                      rules={[
                        {
                          required: true
                        }
                      ]}
                    >
                      <InputNumber style={{ width: '100%' }} />
                    </Form.Item>
                  </div>
                  <Form.Item
                    name='link'
                    label='Title Link'
                    rules={[
                      {
                        required: false,
                        type: 'string',
                        max: 500,
                        min: 1
                      }
                    ]}
                  >
                    <Input addonBefore='https://' />
                  </Form.Item>
                  <Form.Item
                    name='subtitle'
                    label='Subtitle'
                    rules={[
                      {
                        required: false,
                        type: 'string',
                        max: 100,
                        min: 1
                      }
                    ]}
                  >
                    <TextArea autoSize showCount maxLength={100} />
                  </Form.Item>
                  <Form.Item name='date' label='Date'>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 2,
                        justifyContent: 'space-between'
                      }}
                    >
                      <DatePicker
                        placeholder={'Start Date'}
                        style={{ width: '45%' }}
                        format='YYYY-MM-DD'
                        defaultValue={startDate && moment(startDate, 'YYYY-MM-DD')}
                        onChange={(date, value) => {
                          setStartDate(value)
                        }}
                      />
                      <DatePicker
                        placeholder={'End Date'}
                        style={{ width: '45%' }}
                        format='YYYY-MM-DD'
                        defaultValue={endDate && moment(endDate, 'YYYY-MM-DD')}
                        onChange={(date, value) => {
                          setEndDate(value)
                        }}
                      />
                    </div>
                  </Form.Item>
                  <Form.Item name='time' label='Time'>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 2,
                        justifyContent: 'space-between'
                      }}
                    >
                      <TimePicker
                        placeholder={'Start Time'}
                        style={{ width: '45%' }}
                        defaultValue={startTime && moment(startTime, 'HH:mm:ss')}
                        onChange={(date, value) => {
                          setStartTime(value)
                        }}
                      />
                      <TimePicker
                        placeholder={'End Time'}
                        style={{ width: '45%' }}
                        defaultValue={endTime && moment(endTime, 'HH:mm:ss')}
                        onChange={(date, value) => {
                          setEndTime(value)
                        }}
                      />
                    </div>
                  </Form.Item>
                  <Form.Item
                    name='body'
                    label='Description'
                    rules={[
                      {
                        required: false,
                        type: 'string',
                        max: 500,
                        min: 1
                      }
                    ]}
                  >
                    <RichTextEditor style={{ minHeight: 260 }} ref={inputRef} toLoad={toLoad} />
                  </Form.Item>
                  <Form.Item
                    name='images'
                    label='Images'
                    valuePropName='fileList'
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e
                      }
                      return e && e.fileList
                    }}
                    rules={[
                      {
                        required: false
                      }
                    ]}
                  >
                    <Upload.Dragger listType='picture' accept='image/*' customRequest={customRequest}>
                      <p className='ant-upload-drag-icon'>
                        <InboxOutlined />
                      </p>
                      <p className='ant-upload-text'>Click or drag file to this area to upload</p>
                      <p className='ant-upload-hint'>Support for a single or bulk upload.</p>
                    </Upload.Dragger>
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    )
  )
}

export default NewsAddForm
